import { Component,OnInit,Input  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../models/data.types'
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {

  @Input() pageTitle : string;

  private allUsers : Promise<User[]>;
  private user: User;

  constructor(
    private router: Router,
    private apiService: ApiService) { 

      this.user = JSON.parse(localStorage.getItem('currentUser'));
   //   this.allUsers = this.GetAllUsers();
    }

    onEnterSearch(value: string) {
      //this.router.navigateByUrl('/Dashboard/Scheid/Portals/Vitwatch-Portals?title='+value);
      this.router.navigate(['/Dashboard/Scheid/Portals/Vitwatch-Portals'], { queryParams: {title:value, showfavs:0} });
  }
  
    LogoutClick(){

      if(localStorage["originalUser"] == null)
      {
        localStorage.clear();
        this.router.navigate(['/login']);
      }
      else
      {
        this.user = JSON.parse(localStorage.getItem('originalUser'));
        localStorage.setItem('currentUser',localStorage.getItem('originalUser'));
        localStorage.removeItem("originalUser");
        window.location.reload();
      }
    }
   
    // GetAllUsers(){

    //   return   this.apiService.postAs<any>('data/doquery/CW_GetAllUsers',null).then(
    //     response => {
    //           return  response.Items
    //   })

    // }

    // changeLoggedInUser(username: any){

    //   let originalUser : User
    //   if(localStorage["originalUser"] == null)
    //   {
    //      originalUser = JSON.parse(localStorage.getItem("currentUser"));
    //      localStorage.setItem("originalUser",JSON.stringify(originalUser));
    //   }
    //   else
    //   {
    //     originalUser = JSON.parse(localStorage.getItem('originalUser'));
    //   }
           

    //   this.apiService.get<any>('Account/LoginAs?userName='+username).then(
    //     response => {
    //       let session = JSON.parse(JSON.stringify(response));

    //       this.user = new User();
    //       this.user.username = username;
    //       this.user.password = "";
    //       this.user.token = session.accessToken.toString();
    //       this.user.isDeveloper = originalUser.isDeveloper;

    //       localStorage.setItem('currentUser', JSON.stringify(this.user));

    //       window.location.reload();
    //   })

    // }
  
 }



// WEBPACK FOOTER //
// ./src/app/components/app-header/app-header.component.ts